import { render, staticRenderFns } from "./TourContent.vue?vue&type=template&id=4c670cda"
import script from "./TourContent.vue?vue&type=script&lang=js"
export * from "./TourContent.vue?vue&type=script&lang=js"
import style0 from "./TourContent.vue?vue&type=style&index=0&id=4c670cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports